import LocalStorage from "../services/LocalStorage";

export const whitelistCheck = () => {
  if (window?.location) {
    const urlParams = new URLSearchParams(window.location.search);

    if (urlParams.get("code") === "prisma-quests") {
      LocalStorage.setWhitelistStatus(true);
    }
  }
};
